import { createSelector } from 'reselect';

let forceWatchLinksOverride;

if (typeof URLSearchParams !== 'undefined' && typeof location !== 'undefined') {
    const params = new URLSearchParams(location.search);
    const forceWatchLinksParam = params.get('forceWatchLinks');
    if (forceWatchLinksParam !== null) {
        forceWatchLinksOverride = forceWatchLinksParam === 'true';
    }
}

const getViews = (state) => state.views ?? {};
const getConfig = (state) => state.config ?? {};

export default createSelector(
    [getViews, getConfig],
    ({ views, config }) => (
        forceWatchLinksOverride ??
        config?.[views?.view]?.forceWatchLinks ??
        config?.forceWatchLinks ??
        false
    )
);
